import { Phone, Zap, Clock } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

export default function Marquee() {
  // Rotating items - generic (no geolocation)
  const items = [
    { icon: Zap, text: `URGENCE EN COURS · Intervention en 30 min` },
    { icon: Phone, text: `Appelez le ${SITE.phone}` },
    { icon: Clock, text: `Disponible 24h/24 · 7j/7` },
    { icon: Zap, text: `Intervention rapide · Devis gratuit` },
    { icon: Phone, text: `Ligne directe : ${SITE.phone}` },
    { icon: Clock, text: `Réponse en moins d'une sonnerie` },
    { icon: Zap, text: `Sans dégât · Tarif transparent` },
    { icon: Clock, text: `Serrurier certifié A2P` },
  ];

  const list = [...items, ...items];

  return (
    <a
      href={SITE.phoneHref}
      data-testid="trust-marquee"
      className="block bg-[#0A0A0A] hover:bg-red-600 text-white border-y border-white/10 overflow-hidden py-4 transition-colors group"
    >
      <div className="marquee-track">
        {list.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={i} className="flex items-center gap-3 px-6 whitespace-nowrap">
              <span className="w-2 h-2 bg-red-500 group-hover:bg-white rounded-full" />
              <Icon className="w-4 h-4 text-red-500 group-hover:text-white" strokeWidth={2.5} />
              <span className="font-display font-bold uppercase tracking-[0.15em] text-sm">
                {it.text}
              </span>
            </div>
          );
        })}
      </div>
    </a>
  );
}
